function signUpReducer(state = {}, action) {
  switch (action.type) {
    case 'SIGNUP_OTP_CREATED':
      let { statusCode = 0, message = '' } = action;
      let createOtpSignUpState = { ...state, statusCode, message };
      return createOtpSignUpState;
      break;
    case 'SIGNUP_AUTH_SUCCESS':
      let { authSuccess = 0, otpStatusMessage = '' } = action;
      let authUserSignUpState = { ...state, authSuccess, otpStatusMessage };
      return authUserSignUpState;
      break;

    case 'POST_SIGNUP':
      const { postSignUpInfo = {} } = action;
      return { ...state, postSignUpInfo };

    default:
      return state;
  }
}

export default signUpReducer;
